// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__ZOdlw","right":"styles_right__1l1ja"};